import type {
  ProgramMetricsData,
  ProgramMetricsPhicCauseType,
} from "../../../redux/types/programTypes";

export type MetricCardType = "otdc" | "output_hit_rate" | "machine_downtime" | "line_utilization" | "fpy" | "phic_alert_status";

export interface MetricCardDef {
  id: MetricCardType;
  title: string;
  subtitle: string;
  color: string;
}

export interface StageDetailItem {
  label: string;
  field: string;
  format: "number" | "percent";
}

export interface StageDisplayConfig {
  key: string;
  label: string;
  target: number;
  valueField: string;
  prevField: string;
  details?: StageDetailItem[];
}

export interface StageProgram {
  program: string;
  parent_program: string | null;
  cm: string;
  cm_location: string;
  stages: Record<string, Record<string, number | string>>;
}

export interface SingleStageCardProps {
  programs: StageProgram[];
  stageConfigs: StageDisplayConfig[];
  warningOffset: number;
  invert?: boolean;
}

export interface PhicStatusCardProps {
  causeTypeSummary: ProgramMetricsPhicCauseType[];
}

export interface MultiModeListProps {
  cardId: MetricCardType;
  metricsData: ProgramMetricsData;
  isProgramExpanded: (cardId: string, program: string) => boolean;
  toggleProgramExpand: (cardId: string, program: string) => void;
}

export const getValueColor = (value: number, target: number, warningOffset: number, invert = false) => {
  if (invert) {
    return value <= target ? "#1d8102" : value <= target + warningOffset ? "#8D6E0A" : "#d13212";
  }
  return value >= target ? "#1d8102" : value >= target - warningOffset ? "#8D6E0A" : "#d13212";
};

export const seededRandom = (seed: number) => {
  const x = Math.sin(seed * 9301 + 49297) * 233280;
  return x - Math.floor(x);
};
